import _ from 'lodash';

const moduleName = 'SupervisionDesignVersion';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
